import { ComponentGroup } from '../types.js'

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st9{fill:none;stroke:{{strokeColor}};stroke-miterlimit:10;}
    .st12{fill:#232020;stroke:{{strokeColor}};stroke-width:0.5;stroke-miterlimit:10;}
    .st13{fill:#232020;stroke:{{strokeColor}};stroke-width:0.25;stroke-miterlimit:10;}
  </style>
  <g>
    <path class="st12" d="M11.2,14.6c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2-0.1-0.2-0.2c0-0.9,0.3-1.8,1-2.5c0.6-0.7,1.5-1.1,2.4-1.2
    c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.8,0.1-1.6,0.5-2.2,1.1c-0.6,0.6-0.9,1.5-0.9,2.3C11.2,14.5,11.2,14.6,11.2,14.6z"
    />
    <path class="st12" d="M8.8,14.7c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2-0.1-0.2-0.2c0-1.5,0.6-3,1.6-4.2c1-1.1,2.5-1.9,4-2
    c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.2c-1.4,0.1-2.8,0.8-3.8,1.9c-1,1.1-1.5,2.5-1.5,3.9C8.9,14.6,8.9,14.6,8.8,14.7z"/>
    <path class="st12" d="M18.6,15.2c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.9-0.5,1.8-1.1,2.5c-0.7,0.7-1.6,1-2.5,1.1
    c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2c0.8,0,1.6-0.4,2.3-1c0.6-0.6,1-1.4,1-2.2C18.5,15.2,18.5,15.2,18.6,15.2z"/>
    <path class="st12" d="M20.9,15.3c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2,0.1,0.2,0.2c-0.1,1.5-0.8,3-1.9,4.1c-1.1,1.1-2.6,1.7-4.1,1.7
    c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2c1.4,0,2.8-0.6,3.9-1.6c1.1-1,1.7-2.4,1.8-3.8C20.9,15.3,20.9,15.3,20.9,15.3z"/>
    <path class="st13" d="M8.8,6.7C7.9,6.7,7.2,6,7.2,5c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.7,0.7,1.7,1.7C10.5,6,9.8,6.7,8.8,6.7z M8.8,3.9
    C8.2,3.9,7.7,4.4,7.7,5c0,0.6,0.5,1.2,1.2,1.2C9.5,6.2,10,5.7,10,5C10,4.4,9.5,3.9,8.8,3.9z"/>
    <path class="st13" d="M20.9,6.7C20,6.7,19.3,6,19.3,5c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.7,0.7,1.7,1.7C22.6,6,21.8,6.7,20.9,6.7z
    M20.9,3.9c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2C22.1,4.4,21.6,3.9,20.9,3.9z"/>
    <path class="st13" d="M14.9,16.5c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.7,0.7,1.7,1.7
    C16.6,15.7,15.9,16.5,14.9,16.5z M14.9,13.6c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2
    C16.1,14.2,15.6,13.6,14.9,13.6z"/>
    <path class="st13" d="M8.8,26.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.7,0.7,1.7,1.7C10.5,25.9,9.8,26.6,8.8,26.6z
    M8.8,23.8c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2C10,24.3,9.5,23.8,8.8,23.8z"/>
    <path class="st13" d="M20.9,26.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.7,0.7,1.7,1.7
    C22.6,25.9,21.8,26.6,20.9,26.6z M20.9,23.8c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2
    C22.1,24.3,21.6,23.8,20.9,23.8z"/>
    <path class="st13" d="M3.1,16.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.7,0.7,1.7,1.7C4.7,15.9,4,16.6,3.1,16.6z
    M3.1,13.8c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2C4.2,14.3,3.7,13.8,3.1,13.8z"/>
    <path class="st13" d="M26.9,16.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.7,0.7,1.7,1.7
    C28.6,15.9,27.8,16.6,26.9,16.6z M26.9,13.8c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2
    C28.1,14.3,27.6,13.8,26.9,13.8z"/>
    <line class="st9" x1="10.2" y1="4.9" x2="18.2" y2="4.9"/>
    <line class="st9" x1="22" y1="6.2" x2="26.1" y2="12.3"/>
    <line class="st9" x1="4" y1="17.7" x2="7.7" y2="24"/>
    <line class="st9" x1="23" y1="22.7" x2="26.8" y2="16.4"/>
    <line class="st9" x1="3.7" y1="13.5" x2="7.5" y2="7.2"/>
    <line class="st9" x1="11.7" y1="25.1" x2="19.7" y2="25.1"/>
  </g>
</svg>
`

export const iot: ComponentGroup = {
  name: 'IoT',
  description: 'a group of various IoT protocols',
  icon,
  templates: []
}
